import { GenericTableHead } from '../common';
import { EnhancedTableHeadProps } from '../ValuationsTable.types';

const ValuationsTableHead = ({
  order,
  orderBy,
  onRequestSort,
  columns,
  columnWidths,
  onColumnWidthChange,
}: EnhancedTableHeadProps) => (
  <GenericTableHead
    order={order}
    orderBy={orderBy}
    onRequestSort={onRequestSort}
    columns={columns}
    columnWidths={columnWidths}
    onColumnWidthChange={onColumnWidthChange}
  />
);

export default ValuationsTableHead;
